<template>
    <div>
        <div class="columns toolbar-box is-multiline">
            <div class="column is-3">
                <h1 class="title is-3 between-center">
                    <span>Job Costing</span>
                </h1>
            </div>

            <!--<div class="column is-6-tablet is-3-desktop">-->
                <!--<o-field>-->
                    <!--<o-select :expanded="true" placeholder="Select Team" v-model="filters.team_id">-->
                        <!--<option :value="null">Select Team</option>-->
                        <!--<option :value="team.id" v-for="team in teams">{{ team.name }}</option>-->
                    <!--</o-select>-->
                <!--</o-field>-->
            <!--</div>-->
            <!--<div class="column is-6-tablet is-3-desktop">-->
                <!--<multicomplete type="user" v-model="filters.users" placeholder="Select Users" />-->
            <!--</div>-->

            <div class="column is-6-tablet is-3-desktop">
                <o-field>
                    <o-select :expanded="true" placeholder="Select Year" v-model="filters.year">
                        <option :value="year" v-for="year in years">
                            {{ year }}
                        </option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-6-tablet is-3-desktop">
                <o-field>
                    <o-select :expanded="true" placeholder="Select Month" v-model="filters.month">
                        <option :key="month.id" :value="month.id" v-for="month in months">
                            {{ month.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
        </div>

        <chart :chart-data="chartData" @chartclick="handleChartClick" />

        <!--<div class="columns">-->
            <!--<div class="column">-->
                <!--<div class="field is-grouped is-grouped-right">-->
                    <!--<p class="control" v-if="isResetFiltersButtonVisible">-->
                        <!--<a @click.prevent="resetFilters" class="button is-default">-->
                            <!--Reset filters-->
                        <!--</a>-->
                    <!--</p>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->

        <div v-if="timelogs.length">
            <h2 class="title is-3">Timelogs</h2>
            <o-table
                    class="is-responsive is-responsive-desktop"

                    v-if="timelogs.length"
                    :data="timelogs"

                    :bordered="table.bordered"
                    :striped="table.striped"
                    :narrowed="table.narrowed"
                    :checkable="false"
                    :mobile-cards="table.mobileCards"
                    :paginated="table.paginated"
                    :pagination-simple="table.paginationSimple"
                    :per-page="table.perPage"
                    :default-sort-direction="table.defaultSortDirection"
                    :default-sort="table.defaultSort"
                    @sort="onSort"
            >
                <template slot-scope="props">
                    <template>
                        <div v-for="col in tableColumns">
                          <o-table-column
                              :field="col.field"
                              :label="col.field === 'actions' ? '' : col.label"
                              :key="col.field"
                              :sortable="col.sortable"
                          >
                            <router-link v-if="col.field === 'user_id'" :to="{ name: 'users.show', params: { slug: props.row.user_id } }">
                              {{ userNameById(props.row.user_id) | valueOrDefault('–') }}
                            </router-link>
                            <router-link v-if="col.field === 'project_id'" :to="{ name: 'projects.show', params: { slug: props.row.project_id } }">
                              {{ projectNameById(props.row.project_id) | valueOrDefault('–') }}
                            </router-link>
                            <span v-if="col.field === 'hourly_rate'">{{ props.row.hourly_rate | currency }}</span>
                            <span v-if="col.field === 'cost'">{{ props.row.cost | currency }}</span>
                            <span v-if="col.field === 'focus'">{{ timelogActivityName(props.row) }}</span>
                            <span v-if="col.field === 'time'">{{ props.row.time }}</span>
                            <span v-if="col.field === 'note'" v-html="props.row.note"></span>
                            <span v-if="col.field === 'activity_type'">{{ props.row.activity_type }}</span>
                            <span v-if="col.field === 'activity'">{{ dictionaryEntryNameByTypeAndId('timelog-activity', props.row.activity_name) | valueOrDefault }}</span>
                            <span v-if="col.field === 'date'">{{ props.row.created_at | date }}</span>
                            <span v-if="col.field === 'created_at'">{{ props.row.created_at | date }}</span>
                            <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                              <button class="button" slot="trigger">
                                <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                              </button>
                              <o-dropdown-item has-link><a @click="openTimeLogModal(props.row)">View</a></o-dropdown-item>
                            </o-dropdown>
                          </o-table-column>
                        </div>
                    </template>
                </template>
            </o-table>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTimeLogModalActive" has-modal-card>
            <time-log-modal :timelog-prop="timelog"/>
        </o-modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Chart from './job-costing/Chart'
    import ViewTimeLogModal from './../../../components/modals/ViewTimeLog'
    import Table from './../../../mixins/Table'

    export default {
        props: [],

        mixins: [Table],

        components: {
            Chart, ViewTimeLogModal
        },

        computed: {
            ...mapGetters([
                'months',
                'years',
                'userNameById',
                'projectNameById',
                'timelogActivityName',
                'dictionaryEntryNameByTypeAndId',
            ]),

            isResetFiltersButtonVisible() {
                return true
            },
        },

        watch: {
            'filters.month'() {
                this.fetchData()
            },
            'filters.year'() {
                this.fetchData()
            }
        },

        data() {
            return {
                tableName: 'timelogs-index',

                filters: {
                    year: (new Date).getFullYear(),
                    month: moment().format('MM'),
                    // team_id: null,
                    // users: []
                },

                chartData: null,

                currentProjects: [],

                timelogs: [],

                timelog: null,
                isTimeLogModalActive: false
            }
        },

        mounted() {
            this.fetchData()
        },

        methods: {
            fetchData() {
                axios.get(`/api/billings/job-costing`, {params: this.filters})
                    .then(res => {
                        let chartData = {
                            labels: [],
                            datasets: [{
                                label: 'Revenue',
                                backgroundColor: 'rgba(255, 0, 0, .5)',
                                data: []
                            }, {
                                label: 'Expenses',
                                backgroundColor: 'rgba(0, 255, 0, .5)',
                                data: []
                            }]
                        }

                        chartData.labels = []
                        chartData.datasets[0].data = []
                        chartData.datasets[1].data = []
                        this.currentProjects = []

                        _.each(res.data.data, row => {
                            chartData.labels.push(row.name)
                            chartData.datasets[0].data.push(parseFloat(row.billed))
                            chartData.datasets[1].data.push(parseFloat(row.expenses))
                            this.currentProjects.push(row.id)
                        })

                        this.chartData = chartData
                    })
            },

            handleChartClick(index) {
                axios.get(`/api/timelogs`, {params: {project_id: this.currentProjects[index]}})
                    .then(res => {
                        this.timelogs = res.data.data
                        return res
                    })
            },

            openTimeLogModal(timelog) {
                this.timelog = timelog
                this.isTimeLogModalActive = true
            }
        }
    }
</script>
